import { z } from 'zod';
import { graphIdSchema } from './primitives';

export const junctionGateAttributesSchema = z.object({ factScope: z.literal('correlation-epoch'),
  consume: z.literal('once-per-epoch'), predecessorEdgeIds: z.array(graphIdSchema), epochOnRelease: z.enum(['inherit', 'new']),
  close: z.discriminatedUnion('kind', [z.object({ kind: z.literal('all-terminal') }).strict(),
    z.object({ kind: z.literal('window'), origin: z.literal('epoch-created'), durationMs: z.number().int().positive().safe() }).strict(),
  ]).nullable() }).strict();
export type JunctionGateAttributes = z.infer<typeof junctionGateAttributesSchema>;
